import React from 'react';
import { Search } from 'lucide-react';

// Simple Input component
const Input = ({ type, placeholder, className }) => {
  return (
    <input
      type={type}
      placeholder={placeholder}
      className={`pl-10 pr-4 py-2 w-full border rounded-md ${className}`}
    />
  );
};

// Simple Button component
const Button = ({ children, className, onClick }) => {
  return (
    <button
      onClick={onClick}
      className={`py-2 px-4 bg-blue-500 text-white rounded-md hover:bg-blue-600 ${className}`}
    >
      {children}
    </button>
  );
};

export function BlogHeader() {
  return (
    <header className="mb-8">
      <h1 className="text-4xl font-bold mb-4">Our Blog</h1>
      <p className="text-xl text-gray-600 mb-6">
        Discover the latest trends, tips, and insights in e-commerce
      </p>
      <div className="relative">
        <Input
          type="search"
          placeholder="Search articles..."
          className="border rounded-md"
        />
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500" />
        <Button className="absolute right-1 top-1/2 transform -translate-y-1/2">
          Search
        </Button>
      </div>
    </header>
  );
}
